import M$plugin$CatastroSearch from '/home/fbmanas/Documentos/git-sigc/catastrosearch/src/facade/js/catastrosearch';
import M$control$CatastroSearchControl from '/home/fbmanas/Documentos/git-sigc/catastrosearch/src/facade/js/catastrosearchControl';
import M$impl$control$CatastroSearchControl from '/home/fbmanas/Documentos/git-sigc/catastrosearch/src/impl/ol/js/catastrosearchControl';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.CatastroSearch = M$plugin$CatastroSearch;
window.M.control.CatastroSearchControl = M$control$CatastroSearchControl;
window.M.impl.control.CatastroSearchControl = M$impl$control$CatastroSearchControl;
